import { PageHeader } from '@celltrak/ui-components';

import VisitsList from '../VisitsList';
import VisitsFilterBar from '../VisitsFilterBar';
import VisitsFooter from '../VisitsFooter';
import GridHeader from '../GridHeader';
import TotalRecords from '../TotalRecords';

import styles from './VisitsSummary.module.scss';

function VisitsSummary() {
  return (
    <div className={styles.visitsSummaryContainer}>
      <div className={styles.headerContainer}>
        <PageHeader title="Visit Summary Report" />
        <VisitsFilterBar />
        <GridHeader>
          <TotalRecords />
        </GridHeader>
      </div>
      <VisitsList />
      <VisitsFooter />
    </div>
  );
}

export default VisitsSummary;
